import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-10 ml-10" }

import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import ModalFlashMessage from "@/components/Common/ModalFlashMessage.vue"
import RegisterModal from "@/components/Common/RegisterModal.vue"
import flashMessagesType from "@/types/flashMessageType"
import { Ref, ref, reactive, computed } from "vue"
import Api from "@/services/api/ApiServiceFabrick"
import i18n from "@/lang/i18n"


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteModal',
  props: {
    modelValue: { type: Boolean },
    parentIdExistsDepartments: {},
    department: {},
    closeModal: { type: Function },
    showFlash: { type: Function }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const isDeleting: Ref<boolean> = ref(false)
const isDisabled: Ref<boolean> = ref(false)
const flashMessage = reactive({
  message: "",
  show: false,
  type: "info",
  cancel: false
}) as flashMessagesType

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const message = computed(() => {
  if (isHiddenExecButton.value) return `${props.department?.name}${i18n.global.t('pages.departments.deleteModal.informationMessage')}`
  return `${props.department?.name}${i18n.global.t('pages.departments.deleteModal.deleteMessage')}`
})

const isHiddenExecButton = computed(() => {
  return !!props.parentIdExistsDepartments.filter((department) => {
    return department.parent_id == props.department?.id
  })?.length
})

function deleteDepartment() {
  isDeleting.value = true
  if (!props.department) return
  Api().deleteDepartment(props.department.id).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.removeSuccess'), "success", true)
    props.closeModal(true)
  }).catch(() => {
    changeFlashMessages("error", i18n.global.t('pages.common.messages.failedRemove'))
  }).finally(() => {
    isDeleting.value = false
    isDisabled.value = true
  })
}

function changeFlashMessages(resultStatus = "", message = "") {
  flashMessage.type = resultStatus
  flashMessage.message = message
  flashMessage.show = true
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(RegisterModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
    title: _unref(i18n).global.t('pages.departments.deleteModal.title')
  }, {
    "flash-message": _withCtx(() => [
      _createVNode(ModalFlashMessage, {
        id: "flash-message-component",
        message: flashMessage.message,
        show: flashMessage.show,
        type: flashMessage.type,
        cancel: flashMessage.cancel,
        onSetShow: _cache[0] || (_cache[0] = (show) => {flashMessage.show = show})
      }, null, 8, ["message", "show", "type", "cancel"])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(message.value), 1)
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_v_btn, {
        class: "ma-2 reset-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.closeModal(false)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.closeBtn')), 1)
        ]),
        _: 1
      }),
      (!isHiddenExecButton.value)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "ma-2 exec-btn",
            loading: isDeleting.value,
            disabled: isDisabled.value,
            style: _normalizeStyle({
          backgroundColor: isDisabled.value ? '#B3B8BB' : '',
        }),
            onClick: deleteDepartment
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.exec')), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "style"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})